// UnbanIPWidget — admin tool to unban / view banned IPs.
// Extracted from App.jsx (C1 refactor, Phase 2d3a). Behavior-preserving:
// body is byte-identical to the former App.jsx declaration.
//
// Dependencies imported from already-extracted modules (no App.jsx coupling):
//   • useState        -> react
//   • API_BASE        -> ../lib/endpoints.js
//   • getSessionToken -> ../utils/session.js
import { useState } from "react";
import { API_BASE } from "../lib/endpoints.js";
import { getSessionToken } from "../utils/session.js";

export function UnbanIPWidget() {
  const [unbanIp, setUnbanIp] = useState('');
  return (
    <div style={{ display: "flex", gap: 8 }}>
      <input value={unbanIp} onChange={e => setUnbanIp(e.target.value)} placeholder="Enter IP address (e.g. 1.2.3.4)"
        style={{ flex: 1, padding: "8px 12px", borderRadius: 8, border: "1px solid #FED7AA", fontSize: 13, background: "#FFF" }} />
      <button onClick={async () => {
        const ip = unbanIp.trim();
        if (!ip) return alert('Enter an IP address');
        try {
          const res = await fetch(`${API_BASE}/admin/unban`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getSessionToken()}` },
            body: JSON.stringify({ ip }),
          });
          const d = await res.json();
          if (d.ok) { alert(`✅ ${ip} unbanned${d.removed ? '' : ' (was not banned)'}`); setUnbanIp(''); }
          else alert(`❌ ${d.error}`);
        } catch(e) { alert(`❌ ${e.message}`); }
      }} style={{ padding: "8px 18px", background: "#C2410C", border: "none", borderRadius: 8, color: "#FFF", cursor: "pointer", fontWeight: 700, fontSize: 13 }}>
        Unban
      </button>
      <button onClick={async () => {
        try {
          const res = await fetch(`${API_BASE}/admin/banned`, { headers: { 'Authorization': `Bearer ${getSessionToken()}` } });
          const d = await res.json();
          alert(`Banned IPs (${d.count}):\n${d.banned.join('\n') || 'None'}`);
        } catch(e) { alert(`❌ ${e.message}`); }
      }} style={{ padding: "8px 14px", background: "transparent", border: "1px solid #FED7AA", borderRadius: 8, color: "#C2410C", cursor: "pointer", fontWeight: 600, fontSize: 13 }}>
        View Banned
      </button>
    </div>
  );
}
